export const capitalizeFirstLetter = (string) => {
  if (typeof string !== "string" || !string.length) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const normalizeData = (s) => {
  return s.toLowerCase().replace(/ /g, '-');
}